/* eslint-disable max-len */
import React, { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import landingApi from '_api/landing'
import './style.scss'

const GuideRequestForm = () => {
  const { addToast } = useToasts()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contactNo: '',
    groupBuyName: '',
    location: '',
    noOfMembers: '',
    additionalInfo: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const response = await landingApi.createRequireGroup({
        name: formData.name,
        email: formData.email,
        phone: formData.contactNo,
        groupName: formData.groupBuyName,
        address: formData.location,
        memberQty: parseInt(formData.noOfMembers, 10),
        message: formData.additionalInfo || '',
      })

      if (response.msgCode === 70400) {
        addToast('Thank you for your request! We will review and get back to you soon.', {
          appearance: 'success',
          autoDismiss: true,
        })
        setFormData({
          name: '',
          email: '',
          contactNo: '',
          groupBuyName: '',
          location: '',
          noOfMembers: '',
          additionalInfo: '',
        })
      }
    } catch (error) {
      console.error('Error submitting host request form:', error)
      addToast(
        error?.msgResp || 'There was an error submitting your request. Please try again later.',
        {
          appearance: 'error',
          autoDismiss: true,
        }
      )
    }
  }

  return (
    <div className='guide-request-container'>
      <div className='guide-request-content'>
        <p className='guide-text'>
          To ensure a positive experience for everyone in the community, we ask prospective hosts to
          complete a short form so we can better understand your group and support you effectively.
        </p>
        <p className='guide-text'>
          We’ll review your request and reach out to guide you on your group-buy journey with
          Co-bee.
        </p>

        <form className='guide-form' onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='name'>Name</label>
            <input
              type='text'
              id='name'
              name='name'
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              id='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='contactNo'>Contact number</label>
            <input
              type='tel'
              id='contactNo'
              name='contactNo'
              value={formData.contactNo}
              onChange={handleChange}
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='groupBuyName'>Group-buy name</label>
            <input
              type='text'
              id='groupBuyName'
              name='groupBuyName'
              value={formData.groupBuyName}
              onChange={handleChange}
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='location'>Location / Address</label>
            <input
              type='text'
              id='location'
              name='location'
              value={formData.location}
              onChange={handleChange}
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='noOfMembers'>Number of members</label>
            <input
              type='number'
              id='noOfMembers'
              name='noOfMembers'
              value={formData.noOfMembers}
              onChange={handleChange}
              required
            />
          </div>
          <div className='form-group form-group--full'>
            <label htmlFor='additionalInfo'>Additional information (optional)</label>
            <textarea
              id='additionalInfo'
              name='additionalInfo'
              rows={4}
              value={formData.additionalInfo}
              onChange={handleChange}
            />
          </div>

          <div className='form-actions'>
            <button type='submit' className='btn-submit-host'>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default GuideRequestForm
